// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, useMediaQuery, Button, Typography } from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BrowserView, MobileView } from 'react-device-detect';

// types
import PropTypes from 'prop-types';

// project imports
import { MenuList } from './sections';
import { Logo } from '../index';
import { drawerWidth } from 'store/baseConfig';
import { useSelector, useDispatch } from 'react-redux';
import { toggleUserMenu, selectShowUserMenu, selectIsMobile } from 'store/slice/SliceSidebar';

// ==============================|| SIDEBAR DRAWER ||============================== //

const SidebarMain = ({ drawerOpen, drawerToggle, window, menuList, isAdmin }) => {
    const theme = useTheme();
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
    const dispatch = useDispatch();
    
    // 리덕스에서 상태 가져오기
    const showUserMenu = useSelector(selectShowUserMenu);
    const isMobile = useSelector(selectIsMobile);

    const handleToggleUserMenu = () => {
        dispatch(toggleUserMenu());
    };

    // 모바일에서는 관리자 메뉴로 전환 버튼을 표시하지 않음
    const shouldShowToggleButton = isAdmin && !isMobile;

    const drawer = (
        <>
            <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                <Box sx={{ display: 'flex', p: 2, mx: 'auto' }}>
                    <Logo />
                </Box>
            </Box>
            <BrowserView>
                <PerfectScrollbar
                    component="div"
                    style={{
                        height: !matchUpMd ? 'calc(100vh - 56px)' : 'calc(100vh - 88px)',
                        paddingLeft: '0.5rem',
                        paddingRight: '0.5rem',
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <Box sx={{ flex: 1 }}>
                        <MenuList menuList={menuList}/>
                    </Box>
                    {shouldShowToggleButton && (
                        <Box sx={{ p: 2 }}>
                            <Button
                                fullWidth
                                variant="contained"
                                color={!showUserMenu ? 'secondary' : 'primary'}
                                onClick={handleToggleUserMenu}
                                size="small"
                            >
                                {!showUserMenu ? '사원 메뉴로 전환' : '관리자 메뉴로 전환'}
                            </Button>
                        </Box>
                    )}
                </PerfectScrollbar>
            </BrowserView>
            <MobileView>
                <Box sx={{ px: 2, display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <Box sx={{ flex: 1 }}>
                        <MenuList menuList={menuList}/>
                    </Box>
                    {shouldShowToggleButton && (
                        <Box sx={{ py: 2 }}>
                            <Button
                                fullWidth
                                variant="contained"
                                color={!showUserMenu ? 'secondary' : 'primary'}
                                onClick={handleToggleUserMenu}
                                size="small"
                            >
                                {!showUserMenu ? '사원 메뉴로 전환' : '관리자 메뉴로 전환'}
                            </Button>
                        </Box>
                    )}
                </Box>
            </MobileView>
        </>
    );

    const container = window !== undefined ? () => window.document.body : undefined;

    return (
        <Box component="nav" sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : 'auto' }} aria-label="mailbox folders">
            <Drawer
                container={container}
                variant={matchUpMd ? 'persistent' : 'temporary'}
                anchor="left"
                open={drawerOpen}
                onClose={drawerToggle}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        background: theme.palette.background.default,
                        color: theme.palette.text.primary,
                        borderRight: 'none',
                        [theme.breakpoints.up('md')]: {
                            top: '88px'
                        }
                    }
                }}
                ModalProps={{ keepMounted: true }}
                color="inherit"
            >
                {drawer}
            </Drawer>
        </Box>
    );
};

SidebarMain.propTypes = {
    drawerOpen: PropTypes.bool,
    drawerToggle: PropTypes.func,
    window: PropTypes.object,
    menuList: PropTypes.array,
    isAdmin: PropTypes.bool
};

export default SidebarMain;
